<template>
  <v-dialog v-model="dialog" width="520" scrollable>
    <v-card>
      <v-card-title v-text="cardTitle" />
      <v-card-text>
        <external-database-form :data="item" @submit="submit" />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import DialogBusMixin from '@/components/dialogs/mixins/dialog-bus-mixin';
import ExternalDatabaseForm from './ExternalDatabaseForm.vue';

export default {
  name: 'external-database-dialog',
  components: { ExternalDatabaseForm },
  mixins: [DialogBusMixin],
  data: () => ({
    item: null,
  }),
  computed: {
    hasItem() {
      return !!this.item;
    },
    cardTitle() {
      const titles = [
        'Новый источник',
        'Редактировать источник',
      ];
      return titles[Number(this.hasItem)];
    },
  },
  methods: {
    submit(i) {
      this.$emit('submit', i);
      this.dialog = false;
    },
    beforeOpen({ item }) {
      this.item = item;
    },
  },
};
</script>

<style scoped>

</style>
